<template>
    <div>
        <img class="we-banner" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/we-banner.png" alt="">
        <div class="about-us">
            <img class="we-infobgr" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/we-infobgr.png" alt="">
            <div class="we-title">
                <div class="we-title1">
                    <div class="we-title1-line"></div>
                    <div>About us</div>
                </div>
                <div class="we-title2">
                    <span>关于<span style="color: #596875">我们</span></span>
                    <div class="we-title2-line"></div>
                </div>
            </div>
            <div class="about-us-contbg">
                <div class="about-us-cont">炯耀是一家高科技创新公司，成立于2017年，总部位于上海，目前拥有广州和武汉分公司，西安和苏州分公司处于筹建中。我们拥有深厚的行业知识和洞察、丰富的最佳实践、专业的技术、广泛的战略合作，我们坚信创新引领未来，诚信铸就品质；始终致力于以客户为中心，为客户提供高品质战略咨询、产品、研发、运营、营销等在内的下一代整体解决方案。打造金牌服务，并以解决客户问题为最终目标，帮助客户实现新价值。</div>
            </div>
            <div class="about-us-hoverbox">
                <div class="about-us-hover">
                    <div class="about-us-hover-circular">
                        <img src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/we-it1.png" alt="">
                    </div>
                    <div>深厚的行业知识和洞察</div>
                </div>
                <div class="about-us-hover">
                    <div class="about-us-hover-circular">
                        <img src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/we-it2.png" alt="">
                    </div>
                    <div>丰富的最佳实践</div>
                </div>
                <div class="about-us-hover">
                    <div class="about-us-hover-circular">
                        <img src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/we-it3.png" alt="">
                    </div>
                    <div>专业的技术</div>
                </div>
                <div class="about-us-hover">
                    <div class="about-us-hover-circular">
                        <img src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/we-it4.png" alt="">
                    </div>
                    <div>广泛的战略合作</div>
                </div>
            </div>
        </div>
  <!--      <div class="we-map-box">
            <div class="we-title">
                <div class="we-title1">
                    <div class="we-title1-line"></div>
                    <div>Introduction of branch office</div>
                </div>
                <div class="we-title2">
                    <span>分公司<span style="color: #596875">介绍</span></span>
                    <div class="we-title2-line" style="width: 93px;"></div>
                </div>
            </div>
            <div class="we-map">
                <img src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/we-map2.png" alt="">
&lt;!&ndash;                <div class="we-mapInfo">&ndash;&gt;
&lt;!&ndash;                    <div class="we-mapInfo-title">广州</div>&ndash;&gt;
&lt;!&ndash;                    <div class="we-mapInfo-title2">咨询中心</div>&ndash;&gt;
&lt;!&ndash;                </div>&ndash;&gt;
            </div>
        </div>-->
<!--        <div class="we-tab">
            <div class="we-title" style="margin-bottom: 80px;">
                <div class="we-title1">
                    <div class="we-title1-line"></div>
                    <div>Company employee</div>
                </div>
                <div class="we-title2">
                    <span>公司<span style="color: #596875">员工</span></span>
                    <div class="we-title2-line" style="width: 59px;"></div>
                </div>
            </div>
            <swiper class="we-tab-swiper" ref="we" :options="swiperOptions">
                <swiper-slide>
                    <div class="we-slide">
                        <div class="we-slide-cont">
                            <img class="we-userImg" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/we-userImg.png" alt="">
                            <div class="we-slide-userName">席琳•莱西厄</div>
                            <div class="we-slide-userTag">董事长</div>
                            <div class="we-slide-title">标题内容展示</div>
                            <div class="we-slide-info">工作背景文字内容展示工作背景文字内容展示工作背景文字内容展示工作背景文字内容展示工作背景文字内容展示</div>
                            <div class="we-slide-bbg">Tutors Biology, BMAT  +5 more</div>
                        </div>
                        <div class="we-slide-cont">
                            <img class="we-userImg" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/we-userImg.png" alt="">
                            <div class="we-slide-userName">席琳•莱西厄</div>
                            <div class="we-slide-userTag">董事长</div>
                            <div class="we-slide-title">标题内容展示</div>
                            <div class="we-slide-info">工作背景文字内容展示工作背景文字内容展示工作背景文字内容展示工作背景文字内容展示工作背景文字内容展示</div>
                            <div class="we-slide-bbg">Tutors Biology, BMAT  +5 more</div>
                        </div>
                        <div class="we-slide-cont">
                            <img class="we-userImg" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/we-userImg.png" alt="">
                            <div class="we-slide-userName">席琳•莱西厄</div>
                            <div class="we-slide-userTag">董事长</div>
                            <div class="we-slide-title">标题内容展示</div>
                            <div class="we-slide-info">工作背景文字内容展示工作背景文字内容展示工作背景文字内容展示工作背景文字内容展示工作背景文字内容展示</div>
                            <div class="we-slide-bbg">Tutors Biology, BMAT  +5 more</div>
                        </div>
                        <div class="we-slide-cont">
                            <img class="we-userImg" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/we-userImg.png" alt="">
                            <div class="we-slide-userName">席琳•莱西厄</div>
                            <div class="we-slide-userTag">董事长</div>
                            <div class="we-slide-title">标题内容展示</div>
                            <div class="we-slide-info">工作背景文字内容展示工作背景文字内容展示工作背景文字内容展示工作背景文字内容展示工作背景文字内容展示</div>
                            <div class="we-slide-bbg">Tutors Biology, BMAT  +5 more</div>
                        </div>
                        <div class="we-slide-cont">
                            <img class="we-userImg" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/we-userImg.png" alt="">
                            <div class="we-slide-userName">席琳•莱西厄</div>
                            <div class="we-slide-userTag">董事长</div>
                            <div class="we-slide-title">标题内容展示</div>
                            <div class="we-slide-info">工作背景文字内容展示工作背景文字内容展示工作背景文字内容展示工作背景文字内容展示工作背景文字内容展示</div>
                            <div class="we-slide-bbg">Tutors Biology, BMAT  +5 more</div>
                        </div>
                        <div class="we-slide-cont">
                            <img class="we-userImg" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/we-userImg.png" alt="">
                            <div class="we-slide-userName">席琳•莱西厄</div>
                            <div class="we-slide-userTag">董事长</div>
                            <div class="we-slide-title">标题内容展示</div>
                            <div class="we-slide-info">工作背景文字内容展示工作背景文字内容展示工作背景文字内容展示工作背景文字内容展示工作背景文字内容展示</div>
                            <div class="we-slide-bbg">Tutors Biology, BMAT  +5 more</div>
                        </div>
                        <div class="we-slide-cont">
                            <img class="we-userImg" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/we-userImg.png" alt="">
                            <div class="we-slide-userName">席琳•莱西厄</div>
                            <div class="we-slide-userTag">董事长</div>
                            <div class="we-slide-title">标题内容展示</div>
                            <div class="we-slide-info">工作背景文字内容展示工作背景文字内容展示工作背景文字内容展示工作背景文字内容展示工作背景文字内容展示</div>
                            <div class="we-slide-bbg">Tutors Biology, BMAT  +5 more</div>
                        </div>
                        <div class="we-slide-cont">
                            <img class="we-userImg" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/we-userImg.png" alt="">
                            <div class="we-slide-userName">席琳•莱西厄</div>
                            <div class="we-slide-userTag">董事长</div>
                            <div class="we-slide-title">标题内容展示</div>
                            <div class="we-slide-info">工作背景文字内容展示工作背景文字内容展示工作背景文字内容展示工作背景文字内容展示工作背景文字内容展示</div>
                            <div class="we-slide-bbg">Tutors Biology, BMAT  +5 more</div>
                        </div>
                    </div>
                </swiper-slide>
            </swiper>
            <div class="we-swiper-btn">
                <img @click="prev" class="we-prev" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/we-prev.png" alt="">
                <img @click="next" class="we-next" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/we-next.png" alt="">
            </div>
        </div>-->
    </div>
</template>

<script>
    export default {
        name: "we",
        data:vm=>{
            return{

                swiperOptions: {
                    pagination: {
                        el: '#we'
                    },
                    navigation: {
                        nextEl: '.we-next',
                        prevEl: '.we-prev',
                    },
                    slidesPerView: 1,
                    centeredSlides: true,
                    observer: true,
                    observeParents: true,
                    on:{
                        slideNextTransitionStart: function () {
                            console.log(2222);
                        },
                        slidePrevTransitionStart: function () {
                            console.log(33);
                        },
                    }
                },
            }
        },
        methods:{
            prev(type) {
                this.swiper.slidePrev();

            },
            next(type) {
                this.swiper.slideNext();
            },
        },
        computed: {
            swiper() {
                return this.$refs.we.$swiper
            },
        },
    }
</script>

<style lang="less" scoped>
.we-banner{
    margin-top: 7px;
    width: 100%;
}
.we-title{
    width: 1200px;
    margin: 0 auto;
    position: relative;
    .we-title1{
        font-size: 19px;
        position: relative;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding-left: 50px;
        margin-bottom: 10px;
        .we-title1-line{
            width: 100px;
            height: 1px;
            background: #636363;
            position: absolute;
            left: -60px;
        }
    }
    .we-title2{
        position: relative;

        font-size: 34px;
        .we-title2-line{
            width: 59px;
            height: 6px;
            background: #DC0616;
            position: absolute;
            left: 0;
            bottom: 2px;
            z-index: -1;
        }
    }
}
.about-us{
    position: relative;
    width: 100%;
    background: url("https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/we-infobg.png") no-repeat;
    box-sizing: border-box;
    padding-top: 60px;
    .we-infobgr{
        position: absolute;
        right: 0;
        top: -5px;
        width: 600px;
    }
    .about-us-contbg{
        width: 1200px;
        margin: 0 auto;
        position: relative;
        z-index: 1;
        .about-us-cont{
            width: 892px;
            margin-top: 60px;
            font-size: 18px;
            line-height:32px;
        }
    }
    .about-us-hoverbox{
        width: 1200px;
        margin: 100px auto;
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
        transition: all .3s linear;
        .about-us-hover{
            width: 286px;
            height: 249px;
            background: #FFFFFF;
            box-shadow: 1px 11px 27px 0px rgba(0, 0, 0, 0.09);
            border-radius: 20px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            color: #2E4052;
            font-size: 16px;
            .about-us-hover-circular{
                width: 88px;
                height: 88px;
                background: rgba(112, 112, 112, 0.1);
                border-radius: 50%;
                margin-bottom: 20px;
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }
        .about-us-hover:hover{
            box-shadow: 1px 12px 16px 0px rgba(220, 6, 22, 0.33);
            background: url("https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/we-hoverbg.png") no-repeat;
            -webkit-background-size: 100% 100%;
            background-size: 100% 100%;
            color: #fff;
            cursor: pointer;
        }
        .about-us-hover:hover .about-us-hover-circular{
            background: #fff;
        }
    }
}
.we-map-box{
    .we-map{
        position: relative;
        margin: 43px auto 70px auto;
        text-align: center;
/*        .we-mapInfo{
            width: 103px;
            height: 70px;
            background: url("https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/we-mapinfo.png") no-repeat;
            background-size: 100% 100%;
            position: absolute;
            bottom: 80px;
            right: 97px;
            box-sizing: border-box;
            padding: 11px 13px;
            .we-mapInfo-title{
                font-size: 14px;
                color: #DC0716;
            }
            .we-mapInfo-title2{
                font-size: 12px;
            }
        }*/
    }
}
.we-tab{
    position: relative;
    .we-tab-swiper{
        width: 1200px;
        height: 800px;
        margin: 0 auto;
        position: relative;
    }
    .we-swiper-btn{
        width: 1200px;
        height: 800px;
        position: absolute;
        left: 50%;
        margin-left: -600px;
        bottom: 0;
        .we-prev{
            position: absolute;
            top: 50%;
            margin-top: -24px;
            left: -120px;
            cursor: pointer;
        }
        .we-next{
            position: absolute;
            top: 50%;
            margin-top: -24px;
            right: -120px;
            cursor: pointer;
        }
    }

    .we-slide{
        width: 1200px;
        height: 800px;
        .we-slide-cont{
            width: 240px;
            height: 350px;
            margin-right: 70px;
            display: inline-block;
            margin-bottom: 50px;
            text-align: center;
            .we-userImg{
                width: 140px;
                margin-bottom: 10px;
            }
            .we-slide-userName{
                font-size: 20px;
            }
            .we-slide-userTag{
                font-size: 14px;
                margin-bottom: 10px;
            }
            .we-slide-title{
                font-size: 14px;
                font-weight: bold;
            }
            .we-slide-info{
                font-size: 12px;
                color: #7B7B7B;
                margin: 10px 0;
                text-align: left;
                line-height: 21px;
            }
            .we-slide-bbg{
                width: 100%;
                height: 28px;
                background: #F7FBFF;
                border-radius: 5px;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #555;
                font-size: 12px;
            }
        }
        .we-slide-cont:nth-child(4n){
            margin-right: 0px;
        }
    }
}    
</style>